import {
  SET_CATEGORIES
} from './mutationTypes'

export const mutations = {
  [SET_CATEGORIES]: (state, payload) => state.categories = payload
}
